import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zh from './zh.json';

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
] as const;

export type Language = (typeof LANGUAGES)[number]['code'];

const STORAGE_KEY = 'parkingpay.web.lang';

/**
 * English is the default and the fallback.
 *
 * The drivers scanning these QR codes are in Chicago; Chinese is offered
 * because the operator's own team reads it, not because the customer does.
 * Detection order puts an explicit choice first, then the browser's language.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    // zh-CN, zh-TW and zh-Hant all resolve to our single zh bundle.
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export function setLanguage(lang: Language): void {
  void i18n.changeLanguage(lang);
  localStorage.setItem(STORAGE_KEY, lang);
  document.documentElement.lang = lang === 'zh' ? 'zh-CN' : 'en';
}

/** Keeps <html lang> in step so screen readers and Safari translate correctly. */
i18n.on('languageChanged', (lang) => {
  document.documentElement.lang = lang.startsWith('zh') ? 'zh-CN' : 'en';
});

export default i18n;
